import React from "react";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import { privacyVMetaData } from "../seo/metaDeta";

const PrivacyPolicy = () => {
  return (
    <>
      <HelmetWrapper {...privacyVMetaData} />
      <main>
        <div className="container">
          <h3>Privacy Policy</h3>

          <p>Date of the policy: August 12, 2025</p>

          <h5>1.INTRODUCTION</h5>

          <p>
            This Privacy Policy ("Policy") describes how Datazip Solutions India
            Private Limited ("we", "our", or "us") collects, uses, processes,
            shares, and protects your personal data in accordance with the
            Digital Personal Data Protection Act, 2023 ("DPDPA") and other
            applicable data protection laws in India.
          </p>

          <p>
            We are a data analytics company specializing in predictive
            analytics, prescriptive analytics, enterprise decision management,
            descriptive analytics, cognitive analytics, Big Data Analytics,
            retail analytics, supply chain analytics, store assortment and
            stock-keeping unit optimization, marketing optimization and
            marketing mix modelling, web analytics, call analytics, speech
            analytics, sales force sizing and optimization, price and promotion
            modelling, predictive science, credit risk analysis, and fraud
            analytics.
          </p>

          <p>
            We respect your privacy and are committed to protecting your
            personal data. This Policy is designed to provide a clear
            understanding of how we process your personal data, your rights as a
            Data Principal, and how you can exercise those rights.
          </p>

          <h5>2.DEFINITIONS</h5>

          <p> For the purposes of this Privacy Policy:</p>
          <ul>
            <li>
              <b>Personal Data</b> means any data about an individual who is
              identifiable by or in relation to such data{" "}
            </li>
            <li>
              <b>Data Principal</b> means the individual to whom the personal
              data relates
              <a
                href="https://tta.in/the-digital-personal-data-protection-bill-2023-key-highlights-2/"
                target="_blank"
                rel="noopener noreferrer"
              >
                &nbsp;[2]
              </a>
            </li>
            <li>
              <b>Data Fiduciary</b> means any person who alone or in conjunction
              with other persons determines the purpose and means of processing
              of personal data (we are the Data Fiduciary in this context)
            </li>
            <li>
              <b>Data Processor</b> refers to entities that process personal
              data on our behalf
            </li>
            <li>
              <b>Processing </b>means any operation or set of operations
              performed on personal data, including collection, storage,
              alteration, use, disclosure, or erasure
            </li>
          </ul>

          <h5>3.TYPES OF PERSONAL DATA WE COLLECT</h5>

          <p>
            Depending on the services you use and your relationship with us, we
            may collect the following categories of personal data:
          </p>

          <h6> 3.1 Identification and Contact Information</h6>

          <p>
            <ul>
              <li>Name, email address, phone number, postal address</li>
              <li>
                Business contact information if you represent an organization
              </li>
              <li>User credentials for our platforms and services</li>
            </ul>
          </p>

          <h6> 3.2 Technical and Usage Data</h6>

          <p>
            <ul>
              <li>IP address, device information, browser type and version</li>
              <li>Operating system and platform information</li>
              <li>Location data</li>
              <li>
                Information about how you use our website, products, and
                services
              </li>
              <li>Cookie data and similar tracking technologies</li>
            </ul>
          </p>

          <h6> 3.3 Business and Transaction Data</h6>

          <p>
            <ul>
              <li>Details about services you have purchased from us</li>
              <li>Billing and payment information </li>
              <li>
                Customer service interactions and communication preferences
              </li>
            </ul>
          </p>

          <h6> 3.4 Analytics and Derived Data</h6>

          <p>
            <ul>
              <li>Data derived through our analytics services</li>
              <li>Statistical information derived from aggregated data </li>
              <li>
                Behavioral patterns and preferences derived from usage data
              </li>
            </ul>
          </p>

          <h5>4. HOW WE COLLECT PERSONAL DATA</h5>

          <p>We collect personal data through the following methods:</p>

          <ul>
            <li>
              <b>Direct interactions:</b> When you provide your information to
              us by filling forms, creating accounts, contacting us, or
              subscribing to our services
            </li>

            <li>
              <b>Automated technologies:</b> Through cookies, server logs, and
              other similar technologies when you visit our website or use our
              applications
            </li>

            <li>
              <b>Third parties: </b> We may receive personal data about you from
              various third parties such as business partners, service
              providers, and publicly available sources
            </li>

            <li>
              <b>Data analytics: </b>Through our analysis of usage patterns and
              interactions with our services
            </li>
          </ul>

          <h5>5. PURPOSES OF PROCESSING PERSONAL DATA</h5>

          <p>
            We process your personal data for the following specified purposes
          </p>

          <h6>5.1 Service Provision and Management</h6>
          <ul>
            <li>
              To provide and maintain our data analytics services and products
            </li>
            <li>To manage your account and provide customer support</li>
            <li>To process transactions and send related information</li>
            <li>To personalize your experience with our services</li>
          </ul>

          <h6>5.2 Communication and Engagement</h6>
          <ul>
            <li>
              To communicate with you about our services, updates, and changes
              to our policies
            </li>
            <li>To respond to your inquiries, requests, and feedback</li>
            <li>To send service-related notifications and alerts </li>
          </ul>

          <h6>5.3 Business Operations and Improvement</h6>
          <ul>
            <li>To improve our products, services, and website</li>
            <li>
              To conduct research and analysis to enhance our data analytics
              capabilities
            </li>
            <li>To develop new features, products, and services</li>
            <li>
              To measure the effectiveness of our services and operations{" "}
            </li>
          </ul>

          <h6>5.4 Legal and Compliance Purposes</h6>
          <ul>
            <li>
              To comply with legal obligations and regulatory requirements
            </li>
            <li>To enforce our terms, conditions, and policies</li>
            <li>
              To prevent, detect, and investigate fraud, security breaches, and
              other potentially prohibited or illegal activities
            </li>
            <li>
              To protect our rights, property, and safety as well as those of
              our users and the public
            </li>
          </ul>

          <h5>6. LAWFUL BASIS FOR PROCESSING</h5>

          <p>
            We process your personal data based on the following lawful grounds:
          </p>

          <h6>6.1 Consent</h6>

          <p>
            We process your personal data based on your free, specific,
            informed, unconditional, and unambiguous consent. You can withdraw
            your consent at any time through the mechanisms described in Section
            11 of this Policy.
          </p>

          <h6>6.2 Legitimate Uses</h6>

          <p>
            In certain circumstances, we may process your personal data without
            explicit consent where permitted by the DPDPA, including:
          </p>
          <ul>
            <li>Processing necessary for compliance with legal obligations</li>
            <li>Processing for employment-related purposes </li>
            <li>Other purposes specifically permitted under applicable law</li>
          </ul>

          <h5>7. DATA SHARING AND DISCLOSURE</h5>

          <p>
            We may share your personal data with the following categories of
            recipients:
          </p>

          <h6>7.1 Service Providers and Processors</h6>
          <p>
            We may share your personal data with third-party service providers
            who perform services on our behalf, such as:
          </p>

          <ul>
            <li>Cloud hosting and infrastructure providers</li>
            <li>Payment processors</li>
            <li>Customer relationship management systems</li>
            <li>IT and system maintenance providers</li>
            <li>
              Professional advisers including lawyers, auditors, and insurers
            </li>
          </ul>

          <p>
            All our third-party service providers are required to maintain the
            confidentiality and security of your personal data and to use it
            only for the specific purposes for which it is provided.
          </p>

          <h6>7.2 Business Partners</h6>

          <p>
            We may share your personal data with business partners when
            necessary to provide you with our services or as part of joint
            offerings.
          </p>

          <h6>7.3 Legal Requirements</h6>

          <p>
            We may disclose your personal data when required by law, regulation,
            or legal process, such as in response to a court order or a lawful
            request by a public authority.
          </p>

          <h6>7.4 Corporate Transactions</h6>

          <p>
            In the event of a merger, acquisition, reorganization, bankruptcy,
            or other similar event, your personal data may be transferred as
            part of the transaction, in compliance with applicable data
            protection laws.
          </p>

          <h5>8. CROSS-BORDER DATA TRANSFERS</h5>

          <p>
            We may transfer your personal data to countries outside India in
            connection with the purposes outlined in this Privacy Policy. Such
            transfers will comply with the requirements of the DPDPA, including:
          </p>

          <ul>
            <li>
              We will only transfer your personal data to countries not
              restricted by the Central Government of India{" "}
            </li>
            <li>
              We will ensure that appropriate safeguards are in place to protect
              your personal data during international transfers
            </li>
            <li>
              If any additional restrictions on cross-border transfers are
              notified under the DPDPA or its implementing rules, we will comply
              with such requirements
            </li>
          </ul>

          <h5>9. DATA RETENTION</h5>

          <p>
            We retain your personal data only for as long as necessary to
            fulfill the purposes for which it was collected, including for the
            purposes of satisfying any legal, regulatory, accounting, or
            reporting requirements.
          </p>

          <p>We will erase your personal data when:</p>

          <ul>
            <li>
              You withdraw your consent and there is no other legal ground for
              processing
            </li>
            <li>
              The purpose for which the data was collected has been fulfilled
              and retention is no longer necessary
            </li>
            <li>
              Retention is no longer necessary for compliance with legal
              obligations
            </li>
          </ul>

          <p>
            We have implemented appropriate data retention policies to ensure
            that personal data is not kept longer than necessary.
          </p>

          <h5>10. DATA SECURITY</h5>

          <p>
            We have implemented appropriate technical and organizational
            measures to protect your personal data against unauthorized or
            unlawful processing and against accidental loss, destruction, or
            damage.
          </p>

          <p>Our security measures include:</p>

          <ul>
            <li> Encryption of personal data where appropriate</li>
            <li>
              Regular testing and evaluation of the effectiveness of our
              security measures
            </li>
            <li> Access controls and authentication procedures</li>
            <li> Regular security assessments and audits </li>
            <li> Staff training on data protection and security</li>
          </ul>

          <h5>11. YOUR RIGHTS AS A DATA PRINCIPAL</h5>

          <p>
            Under the DPDPA, you have the following rights regarding your
            personal data:{" "}
          </p>

          <h6>11.1 Right to Access Information</h6>

          <p>You have the right to obtain:</p>

          <ul>
            <li>Confirmation of whether we process your personal data</li>
            <li>A summary of the personal data being processed</li>
            <li>Information about the processing activities</li>
            <li>Information about data sharing with other entities</li>
          </ul>

          <h6>11.2 Right to Correction and Erasure</h6>

          <p>You have the right to:</p>

          <ul>
            <li>
              Request correction of inaccurate or incomplete personal data
            </li>
            <li>Request completion of incomplete personal data</li>
            <li>
              Request erasure of personal data that is no longer necessary for
              the purpose for which it was collected
            </li>
          </ul>

          <h6>11.3 Right to Withdraw Consent</h6>

          <p>
            You have the right to withdraw your consent at any time. The
            withdrawal of consent will not affect the lawfulness of processing
            based on consent before its withdrawal.
          </p>

          <h6>11.4 Right to Nomination</h6>

          <p>
            You have the right to nominate another individual to exercise your
            rights in the event of your death or incapacity.
          </p>

          <h6>11.5 Right to Grievance Redressal</h6>

          <p>
            You have the right to file a complaint regarding any violation of
            your rights under the DPDPA.
          </p>

          <h5>12. HOW TO EXERCISE YOUR RIGHTS</h5>

          <p>You can exercise your rights by:</p>

          <ul>
            <li>
              Contacting our Data Protection Officer at shubham@datazip.io
            </li>
            <li>
              Using the dedicated rights management section in your account
              settings on our platform
            </li>
            <li>
              Submitting a request through our website at
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSe5ziZx-8CQP3bYhthiXcvT46asK1mdHm5UL4LRu0eFL8zFuw/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                &nbsp; link
              </a>
            </li>
          </ul>

          <p>
            We will respond to your request within 3 working days of receiving
            it. In certain cases, we may need additional information to verify
            your identity before processing your request.
          </p>

          <p>
            If you are not satisfied with our response, you have the right to
            file a complaint with the Data Protection Board of India.
          </p>

          <h5>13. DATA BREACH NOTIFICATION</h5>

          <p>
            In the event of a personal data breach that is likely to result in a
            risk to your rights and freedoms, we will:
          </p>

          <ul>
            <li>
              Notify the Data Protection Board of India without undue delay
            </li>
            <li>
              Notify you as a Data Principal in a clear and plain language about
              the nature of the breach and measures taken to address it
            </li>
            <li>Implement measures to mitigate potential adverse effects</li>
          </ul>

          <h5>14. COOKIES AND SIMILAR TECHNOLOGIES</h5>

          <p>
            Our website and services use cookies and similar tracking
            technologies to collect and store certain information. These
            technologies help us analyze trends, administer the website, track
            users' movements around the website, and gather demographic
            information about our user base as a whole.
          </p>

          <p>
            You can control cookies through your browser settings and other
            tools. Please note that blocking certain cookies may impact your
            experience of our website and limit access to certain features.
          </p>

          <h5>15. CHILDREN'S PRIVACY</h5>

          <p>
            We do not knowingly collect personal data from children under the
            age of 18 without obtaining verifiable consent from their parents or
            legal guardians as required by the DPDPA.
          </p>

          <p>
            If we learn that we have collected personal data from a child
            without appropriate parental consent, we will take steps to delete
            that information as quickly as possible.
          </p>

          <p>
            Parents who believe we may have collected personal data from their
            child can contact us at privacy@datazip.io
          </p>

          <h5>16. CHANGES TO THIS PRIVACY POLICY</h5>

          <p>
            We may update this Privacy Policy from time to time to reflect
            changes in our practices, services, or applicable laws and
            regulations. The updated policy will be posted on our website with
            the "Last Updated" date at the top.
          </p>

          <p>
            We encourage you to review this Privacy Policy periodically for any
            changes. Significant changes will be notified to you through email
            or prominent notice on our website before the changes become
            effective.
          </p>

          <h5>17. CONTACT US</h5>

          <p>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or our data processing practices, please contact:
          </p>

          <section aria-labelledby="dpo-heading">
            <p>
              Data Protection Officer : &nbsp;
              <strong>Shubham Baldava</strong>
            </p>
            <address>
              #677, 1st Floor, Suite No. 1223
              <br />
              27th Main, 13th Cross
              <br />
              HSR Layout, Sector 1, Bangalore
              <br />
              Karnataka, India 560102
            </address>
            <p>
              Email: <a href="mailto:shubham@datazip.io">shubham@datazip.io</a>
              <br />
              Phone: <a href="tel:+919403613633">+91 9403613633</a>
            </p>
          </section>

          <h5>18. GRIEVANCE REDRESSAL</h5>

          <p>
            If you have any grievances or complaints regarding the processing of
            your personal data, you can contact our Grievance Officer:
          </p>

          <p>
            <p>
              Email: <a href="mailto:sandeep@datazip.io ">sandeep@datazip.io</a>
              <br />
              Phone: <a href="tel:+919748485583">+91 9748485583</a>
            </p>
          </p>

          <p>
            We will acknowledge receipt of your complaint within 2 working days
            and resolve it within 5 working days.
          </p>
          <p>
            If you are not satisfied with our response, you have the right to
            file a complaint with the Data Protection Board of India.
          </p>

          <h5>19. GOVERNING LAW</h5>
          <p>
            This Privacy Policy is governed by the laws of India, particularly
            the Digital Personal Data Protection Act, 2023, and its implementing
            rules and regulations.
          </p>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicy;
